import { enqueue_event } from "../../client";

const Button = ({ event, eventarg, children, ...rest }) => {
    return (
        <button onClick={() => enqueue_event(event, eventarg)} {...rest}>
            {children}
        </button>
    );
};

export default Button;
